import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import counterReducer from '../features/counter/counterSlice'
import calendarReducer from '../features/calendar/calendarSlice'
import authReducer from '../features/auth/authSlice'
import timesheetReducer from '../features/timesheet/timesheetSlice'

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    calendar: calendarReducer,
    auth: authReducer,
    timesheet: timesheetReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
